<template>
	<div v-on="$listeners" class="surf-inline-two-text-style4 surf-transition-hover-lift">
		<div class="content">
			<div class="value-section">
				<div class="value text-overflow">{{ formattedItem.value }}</div>
				<div class="sub-values">
					<div v-for="(item, index) in formattedItem.valueList" :key="index" class="sub-value-item">
						<span class="sub-value">{{ item }}</span>
						<span v-if="index < formattedItem.valueList.length - 1" class="separator">|</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	item: {
		type: Object,
		default: () => ({})
	},
	formatter: {
		type: Function,
		default: null
	}
});

const formattedItem = computed(() => {
	if (props.formatter && typeof props.formatter === 'function') {
		const formattedData = props.formatter(props.item);
		return { ...props.item, ...formattedData };
	}
	return props.item;
});
</script>

<style lang="less" scoped>
.surf-inline-two-text-style4 {
	padding: 10px 16px;
	border-radius: 8px;
	background-color: var(--surf-secondary-color);
	cursor: pointer;

	.content {
		.value-section {
			display: flex;
			flex-direction: column;

			.value {
				color: var(--surf-inverse-color);
				font-size: 14px;
				font-weight: 400;
				line-height: 18px;
			}

			.sub-values {
				margin-top: 8px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				gap: 6px;

				.sub-value-item {
					display: flex;
					align-items: center;
					gap: 6px;

					.sub-value {
						color: rgba(var(--surf-inverse-color-rgb), 0.4);
						font-size: 14px;
						font-weight: 400;
						line-height: 18px;
					}

					.separator {
						color: rgba(var(--surf-inverse-color-rgb), 0.1);
						font-size: 14px;
						font-weight: 400;
						line-height: 18px;
					}
				}
			}
		}
	}
}

.mob-surf-layout {
	.surf-inline-two-text-style4 {
		padding: 16px 12px;

		.content {
			.value-section {
				.value {
					font-size: 15px;
					line-height: 20px;
				}
				.sub-values {
					margin-top: 10px;

					.sub-value,
					.separator {
						font-size: 12px;
						line-height: 16px;
					}
				}
			}
		}
	}
}
</style>
